export const initialState: FormType = {
  token: '',
  reference: '',
  newPassword: '',
  newPasswordConfirm: '',
};

export const initialErrors: Errors = {
  newPassword: false,
  newPasswordConfirm: null,
};

export const passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[-_&!?#*\$])[a-zA-Z\d-_&!?#*\$]{8,}$/;
